import script from "./MST05_004INS.vue?vue&type=script&setup=true&lang=js"
export * from "./MST05_004INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__